// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { emptyCartAlertStyles } from "@sc/App/Widgets/EmptyCartAlert/EmptyCartAlert";
import { color } from "@sc/XDL/Utilities";
import { css } from "styled-components";

emptyCartAlertStyles.alertWrapper = {
    css: css`
        height: 33px;
        display: flex;
        align-items: center;
        background: ${color("common.ui2")};
        border-top: 1px solid ${color("common.border")};
    `,
};
emptyCartAlertStyles.container = {
    css: css`
        text-align: center;
        position: relative;
        padding: 10px 0;
        display: flex;
        justify-content: center;
        align-items: center;
    `,
};
emptyCartAlertStyles.textStyles = {
    css: css`
        &&&,
        p {
            text-align: center;
            font-size: 12px;
            line-height: 14px;
            color: ${color("text.main")};
            margin-bottom: 0;
        }
        padding-right: 20px;
    `,
};
